import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M18.8097166,7.07287449 L13.6639676,7.07287449 L15.8744939,0.267206478 C15.9878543,-0.0809716599 16.4817814,-0.0809716599 16.5991903,0.267206478 L18.8097166,7.07287449 L18.8097166,7.07287449 Z"
});

var SvgGitlab = function SvgGitlab(props) {
  return _ref;
};

export default SvgGitlab;